module.exports = __webpack_public_path__ + "img/Pic_OnlC_Ks_b.f5422b60.png";